import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SummaryInfoCard } from '../../../services';

@Component({
    selector: 'wdx-ff-summary-info-cards',
    templateUrl: './form-summary-info-cards.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class FormSummaryInfoCardsComponent {
    @Input() infoCards!: SummaryInfoCard[];
}
